// extracted by mini-css-extract-plugin
export default {"about":"About_about__muJRg","slideChange":"About_slideChange__kNGId"};